import '@justgiving/totaliser/src/Totaliser.scss';
import '@justgiving/totaliser/src/themes/PixelHeart/PixelHeart.scss';

import React, { FunctionComponent } from 'react';

import { gql } from '@apollo/client';
import { Totaliser, Pudsey } from '@justgiving/totaliser';
import '@justgiving/totaliser/src/themes/Pudsey/Pudsey.scss';

import { TotaliserWrapperFragment } from '../../../types/__generated__';
import usePageQuery, { buildQuery } from '../../hooks/usePageQuery';
import TotaliserWrapperSkeleton from '../TotaliserWrapperSkeleton/TotaliserWrapperSkeleton';

import './TotaliserWrapper.scss';
import { isCharity } from '../../utils/typeGuards';
import { useBasePageQuery, usePageMeta } from '../../hooks';

const FRAGMENT = buildQuery(gql`
  fragment TotaliserWrapper on Page {
    id
    targetWithCurrency {
      value
    }
    donationSummary {
      totalAmount {
        value
      }
    }
  }
`);

const TotaliserWrapper: FunctionComponent = () => {
  const { loading, error, refetch, data = null } = usePageQuery<
    TotaliserWrapperFragment
  >(FRAGMENT, {
    notifyOnNetworkStatusChange: true,
  });
  const basePageData = useBasePageQuery();
  const { pageType } = usePageMeta();

  if (loading) {
    return <TotaliserWrapperSkeleton animated displayRefreshButton={false} />;
  }

  if (error) {
    return <TotaliserWrapperSkeleton onRefresh={refetch} />;
  }

  if (!data) {
    return null;
  }

  const target = data.targetWithCurrency?.value;

  if (!target) {
    return null;
  }

  const totalAmount = data.donationSummary?.totalAmount?.value ?? 0;
  const percentageOfTarget = (totalAmount / target) * 100;

  const beneficiaryNodes =
    basePageData.data?.page?.relationships?.beneficiaries.nodes;
  const firstBeneficiary =
    beneficiaryNodes && beneficiaryNodes.length > 0
      ? beneficiaryNodes[0]
      : null;
  const isChildrenInNeedPage = Boolean(
    ['fundraising', 'campaign'].includes(pageType) &&
      firstBeneficiary &&
      isCharity(firstBeneficiary) &&
      firstBeneficiary.legacyId === '181821',
  );

  return (
    <Totaliser
      className="jg-pages-totaliser-main"
      percent={percentageOfTarget}
      size="auto"
      isAnimated
    >
      {isChildrenInNeedPage ? <Pudsey /> : null}
    </Totaliser>
  );
};

export default TotaliserWrapper;
